import { GatsbyImage, GatsbyImageProps, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";


type Props = Omit<GatsbyImageProps, 'image' | 'alt'> & {
    url: string | null | undefined
    alt: string | null | undefined
    image: IGatsbyImageData | undefined | null
    width?: number | string
    height?: number | string
}

export const GatsbyImageWithFallback = ({ image, url, alt, width, height, ...other }: Props): React.ReactNode | null => {
    if (!image && !url) {
        return null;
    }

    if (!image) {
        if (url) return <img src={url} alt={alt || ''} loading="lazy" width={width} height={height} style={{ ...other.imgStyle, ...other.style }} />

        return null;
    }
    return (
        <GatsbyImage {...other} style={other.style} image={image} alt={alt || ''} />
    )
}